import React, { Component } from 'react';
import ListTable from '../List-Table';
import TabListTable from '../TabList/TabListTableFigma';

class ItemDetailBox extends Component {
  getResolvedType() {
    if (this.props.getItemTypeFunction) {
      return this.props.getItemTypeFunction(this.props.item);
    }
    return this.props.type;
  }

  render() {
    const resolvedType = this.getResolvedType();
    if (
      this.props.selected === this.props.item[this.props.nameOfTheIdField] &&
      resolvedType.FieldsToShowInListTable !== undefined &&
      resolvedType.FieldsToShowInListTable[0] !== undefined
    ) {
      return 'tabName' in resolvedType.FieldsToShowInListTable[0] ? (
        <div className='bravo-ds list-detail-box'>
          <TabListTable
            caption={this.props.type.nameOfTheItemDetailList(this.props.item)}
            data={this.props.item}
            moneyFields={this.props.type.MoneyFields}
            moneyFieldsSecondary={this.props.type.MoneyFieldsSecondary}
            dateFields={this.props.type.DateFields}
            dateOnlyFields={this.props.type.DateOnlyFields}
            currency={this.props.item[this.props.type.Currency()]}
            currencySecondary={this.props.item[this.props.type.CurrencySecondary()]}
            fieldsToShow={resolvedType.FieldsToShowInListTable}
            boolFields={this.props.type.BoolFields}
            selected={this.props.selected}
            type={this.props.type}
            clickOnCancel={() => this.props.clickOnCancel()}
            popupEnabled={this.props.popupEnabled}
            openOnTabName={this.props.openOnTabName}
          />
        </div>
      ) : (
        <div className='bravo-ds list-detail-box'>
          <ListTable
            caption={this.props.type.nameOfTheItemDetailList(this.props.item)}
            data={this.props.item}
            moneyFields={this.props.type.MoneyFields}
            moneyFieldsSecondary={this.props.type.MoneyFieldsSecondary}
            dateFields={this.props.type.DateFields}
            dateOnlyFields={this.props.type.DateOnlyFields}
            currency={this.props.type.Currency()}
            currencySecondary={this.props.type.CurrencySecondary()}
            fieldsToShow={resolvedType.FieldsToShowInListTable}
            boolFields={this.props.type.BoolFields}
            selected={this.props.selected}
          />
        </div>
      );
    }
    return null;
  }
}

export default ItemDetailBox;
